import { useTranslations } from "next-intl";
import Container from "../sections/container/Container";
import Layout from "../sections/layout/Layout";
import StoreFinder from "src/components/store-finder/StoreFinder";
import { GetStaticProps } from "next";
import getTranslations from "src/helpers/localization-helpers/getTranslations";
interface StoreFinderProps {}

const StoreFinderPage = ({}: StoreFinderProps) => {
  const t = useTranslations("StoreLocator");
  return (
    <Layout
      pageTitle={t("store_locator")}
      showStickyFooterNavigationButton={true}
      description={t("offline_locations")}
    >
      <>
        <Container>
          <section>
            <StoreFinder />
          </section>
        </Container>
      </>
    </Layout>
  );
};

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  if (!locale) {
    throw new Error(`locale is not passed to getStaticProps`);
  }

  const translations = getTranslations(locale);

  return {
    props: {
      translations,
    },
  };
};

export default StoreFinderPage;
